import * as React from "react";

import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Field, reduxForm, change } from "redux-form";
import {
  getStudentTaskDeliver,
  saveLink,
} from "../../../actions/Action_Student";
import {
  Dropdown,
  TextField,
  autobind,
  PrimaryButton,
  ActionButton,
  DefaultButton,
  Label,
  Toggle,
  IconButton,
  Spinner,
  SpinnerSize,
} from "office-ui-fabric-react";
import DatePicker from "react-datepicker";
import * as moment from "moment";
import ReactQuill from "react-quill"; // Typescript
import { ROOT_URL, SP_HOST_URL } from '../../../actions/constants';
import axios from 'axios';

export interface ILinkFormProps {
  intitialLinks: any[];
  studenttask: any;
  handleSubmit: any;
  getStudentTaskDeliver(task: any);
  saveLink(link: any);
}
export interface ILinkFormState {
  linkCollection: any[];
  linksBeingDeleted: string[];
  Grade?: string;
  GradeModifier?: string;
}
let comment = "";
class LinkForm extends React.Component<ILinkFormProps, ILinkFormState> {
  constructor(props) {
    super(props);
    console.log("constructor", props);
    this.state = {
      linksBeingDeleted: [],
      linkCollection: props.studenttask.LinksCollection || [],
    };
    //comment = this.props.studenttask.GradingComment;
  }

  /****************************
          Event handlers
   ****************************/

  onFormSubmit = async (values) => {
    console.log("submitted", values, this.state.linkCollection);
    if(values.Link)
    {
      let tmp = JSON.parse(JSON.stringify(this.props.studenttask));
      if (
        this.state.linkCollection &&
        this.state.linkCollection.length > 0
      ) {
        tmp.Links = `${this.state.linkCollection.join("|")}|${values.Link}`;
      } else {
        tmp.Links = values.Link;
      }
      // this.props.saveLink(tmp).then((updated) => {
      //   console.log("updated", updated);
      //   this.props.getStudentTaskDeliver(tmp);
      // });
      await this.saveStudentLinks(tmp);
    }
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    switch (name) {
      case "Grade":
        this.setState({ Grade: value });
        break;
      case "GradeModifier":
        this.setState({ GradeModifier: value });
        break;
      default:
        comment = value;
        break;
    }
  }

  handleChangeQuill(html) {
    comment = html;
  }
  onDeleteClick() {}

  /****************************   
          Helper methods
   ****************************/

  formatFormValueDatesToDateString(values) {
    return values;
  }

  formatExternalLink(url) {
    if (!url) return "";
    return url.startsWith("http://") || url.startsWith("https://") 
      ? url 
      : `https://${url}`;
  }

  saveStudentLinks = async (studentTask) => {
    try {
      const updatedStudentTask = await axios.post(`${ROOT_URL}/SaveStudentLink${SP_HOST_URL}`, studentTask, {
        headers: {
            Authorization: localStorage.getItem('id_token')
        }
      });
      this.setState({ linkCollection: updatedStudentTask.data.LinksCollection });
    } catch (error) {
      console.error("Error saving student links:", error);
    }
  }

  /****************************
          Render methods
   ****************************/
  renderTextField(field) {
    const {
      meta: { touched, error },
    } = field;

    return <TextField errorMessage={touched ? error : ""} {...field.input} />;
  }
  render() {
    const { handleSubmit } = this.props;

    return (
      <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
  
        <div className="ms-Grid-row mt-10">
          <div className="ms-Grid-col ms-sm12">
            <div className="ms-Grid-col ms-sm8" style={{paddingLeft:0, paddingRight:0}}>
            <Label style={{fontWeight: 'bold'}}>Legg til lenker</Label>
                <Field
                  name="Link"
                  label="" // Custom fields variables can be fetched in component (i.e. field.label)
                  required={true}
                  component={this.renderTextField}
                />
            </div>
            <div className="ms-Grid-col ms-sm4">
              <ActionButton
                    iconProps={{ iconName:"Add" }}
                    style={{marginTop: '23px'}}
                    onClick={handleSubmit(this.onFormSubmit.bind(this))}
                  >Legg til lenke
                  
              </ActionButton>
            </div>
               
          </div>
               
        </div>

        <ul id="addedlinks">
          {this.state.linkCollection &&
            this.state.linkCollection.map((link) => {
              return <li className="addedlink" >
                <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                  <a target="_blank" href={this.formatExternalLink(link)}>
                    {link}
                  </a>
                  {this.state && this.state.linksBeingDeleted && this.state.linksBeingDeleted.includes(link) ? (
                    <Spinner style={{marginLeft: "1.5em"}}
                      size={SpinnerSize.medium}
                    ></Spinner>
                  ) : (
                    <ActionButton
                      iconProps={{ iconName: "Delete" }}
                      title="Slett"
                      onClick={async () => {
                        let tmp = JSON.parse(JSON.stringify(this.props.studenttask));
                        tmp.LinksCollection = this.state.linkCollection.filter(
                          (l) => l !== link
                        );
                        tmp.Links = tmp.LinksCollection.join("|");
                        this.setState(
                          (prevState) => ({
                            linksBeingDeleted: [
                              ...(prevState.linksBeingDeleted || []),
                              link,
                            ],
                          }),
                          async () => {
                            try {
                              await this.saveStudentLinks(tmp);
                            } catch (error) {
                              console.error("Error deleting link:", error);
                            } finally {
                              this.setState((prevState) => ({
                                linksBeingDeleted: prevState.linksBeingDeleted.filter(
                                  (l) => l !== link
                                ),
                              }));
                            }
                          }
                        );

                      }}
                    />
                  )}

                </div>
              </li>;
            })}
        </ul>
      </form>
    );
  }
}

function validate(values) {
  const errors: any = {};

  return errors;
}

const mapStateToProps = (state, ownProps) => {
  console.log("stateform", state);
  return {
    studenttask: state.StudentReducer.studenttask,
  };
};

export default reduxForm({
  form: "EvalForm",
  validate,
  enableReinitialize: true,
})(
  connect(mapStateToProps, {
    getStudentTaskDeliver,
    saveLink,
  })(withRouter(LinkForm))
);
